// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --primary-color: rgb(31, 64, 90) !important;
  --secondary-color: rgb(30, 82, 121) !important;
  --background-light: rgb(239 248 255) !important;
  --text-white: white !important;
  --hover-color: rgb(50, 80, 110) !important;
  --box-shadow: 0 0 10px rgba(0, 0, 0, 0.1) !important;
  --border-radius: 8px !important;
  --h2-font-size: 1.3rem !important;
  --h3-font-size: 1rem !important;
  --ul-padding: 0rem 0.5rem 1rem 1rem !important;
  --a-color: rgb(24, 49, 234) !important;

}

.custom-h2 {
  font-size: var(--h2-font-size);
  color: var(--primary-color);
  font-weight: bold;
  padding-bottom: 10px;
}

h3 {
  font-size: var(--h3-font-size);
  color: var(--secondary-color);
  font-weight: bold;
}

ul {
  padding: var(--ul-padding);
  margin: var(--ul-margin);
  list-style-type: disc;
}

a {
  color: var(--a-color);
}

body {
  background-color: var(--background-light);
}

.userview_container {
  max-width: 93%;
  position: inherit;
}

.bordered-div {
  padding: 30px;
  background-color: #f9f9f9;
  border: 4px solid var(--primary-color);
  border-radius: var(--border-radius);
  box-shadow: var(--box-shadow);
  width: 100%;
  line-height: 20px;
  border-top-left-radius: 0;
}

.inner-content {
  padding: 20px;
  text-align: center;
}

p {
  /* color: var(--primary-color); */
  font-size: 14px;
}

.bgv_content {
  color: var(--primary-color);
  font-size: 14px;
}

h1 {
  margin-left: 30px;
}

/* Ant Design tabs */

.ant-tabs-nav-list {
  width: 99%;
}

.custom-tabs .ant-tabs-tab {
  color: var(--text-white);
  font-size: 16px;
  text-align: center;
  font-family: Arial, Helvetica, sans-serif;
  margin: 0;
  /* background-color: var(--secondary-color); */

}

/* Active Ant Design tabs */
.custom-tabs .ant-tabs-tab-active {
  font-weight: bold;
  background-color: var(--primary-color);
}

ant-tabs-tab-btn {
  color: #1f415b;
}

.ant-tabs-nav {
  /* background-color: var(--background-light); */
  border-radius: var(--border-radius);
  /* padding-top: 20px; */
  /* margin-top: 20px !important; */
  width: 100%;
}

.ant-tabs-ink-bar {
  background-color: var(--text-white);
}

.ant-tabs-content-holder {
  /* background-color: var(--background-light); */
  /* margin-top: -18px; */
  /* padding-bottom: 20px; */
}

.custom-button-download {
  background-color: var(--primary-color) !important;
  border-color: var(--primary-color) !important;
  color: var(--text-white) !important;
  margin-bottom: 10px !important;
}

.custom-button-upload {
  background-color: var(--primary-color) !important;
  border-color: var(--primary-color) !important;
  color: var(--text-white) !important;
  margin: 10px !important;
}

.custom-button-download:hover {
  background-color: var(--hover-color) !important;
  border-color: var(--hover-color) !important;
  font-size: 16px;
}

.custom-button-upload:hover {
  background-color: var(--hover-color) !important;
  border-color: var(--hover-color) !important;
  font-size: 16px;
}

/* Checkbox elements */
.custom-checkbox .ant-checkbox-inner {
  border-color: var(--primary-color);
}

/* Checked checkbox elements */
.custom-checkbox .ant-checkbox-checked .ant-checkbox-inner {
  background-color: var(--primary-color);
  border-color: var(--primary-color);
}

/* Checkbox tick mark */
.custom-checkbox .ant-checkbox-checked .ant-checkbox-inner::after {
  border-color: var(--text-white);
}

/* Card tab navigation in Ant Design */
.custom-tabs .ant-tabs-card>.ant-tabs-nav .ant-tabs-tab-active {
  color: #fff !important;
  background: #1f415b !important;
}

/* Card tabs in Ant Design */
.custom-tabs .ant-tabs-card>.ant-tabs-nav .ant-tabs-tab {
  background: #ddd;
  color: #1f415b;
}

/* Active card tab button in Ant Design */
.custom-tabs .ant-tabs .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {
  color: #fff;
}

.custom-header-userattended .ant-table-thead > tr > th {
  background-color: var(--color-primary); 
  color: white;
  font-weight: bold;
  text-align: center;
}`, "",{"version":3,"sources":["webpack://./src/gitsubmodules/trackon/src/pages/UserView/UserView.css"],"names":[],"mappings":"AAAA;EACE,2CAA2C;EAC3C,8CAA8C;EAC9C,+CAA+C;EAC/C,8BAA8B;EAC9B,0CAA0C;EAC1C,oDAAoD;EACpD,+BAA+B;EAC/B,iCAAiC;EACjC,+BAA+B;EAC/B,8CAA8C;EAC9C,sCAAsC;;AAExC;;AAEA;EACE,8BAA8B;EAC9B,2BAA2B;EAC3B,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,8BAA8B;EAC9B,6BAA6B;EAC7B,iBAAiB;AACnB;;AAEA;EACE,0BAA0B;EAC1B,wBAAwB;EACxB,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,sCAAsC;EACtC,mCAAmC;EACnC,6BAA6B;EAC7B,WAAW;EACX,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,iCAAiC;EACjC,eAAe;AACjB;;AAEA;EACE,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA,oBAAoB;;AAEpB;EACE,UAAU;AACZ;;AAEA;EACE,wBAAwB;EACxB,eAAe;EACf,kBAAkB;EAClB,yCAAyC;EACzC,SAAS;EACT,8CAA8C;;AAEhD;;AAEA,2BAA2B;AAC3B;EACE,iBAAiB;EACjB,sCAAsC;AACxC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,+CAA+C;EAC/C,mCAAmC;EACnC,uBAAuB;EACvB,iCAAiC;EACjC,WAAW;AACb;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,+CAA+C;EAC/C,uBAAuB;EACvB,0BAA0B;AAC5B;;AAEA;EACE,iDAAiD;EACjD,6CAA6C;EAC7C,mCAAmC;EACnC,8BAA8B;AAChC;;AAEA;EACE,iDAAiD;EACjD,6CAA6C;EAC7C,mCAAmC;EACnC,uBAAuB;AACzB;;AAEA;EACE,+CAA+C;EAC/C,2CAA2C;EAC3C,eAAe;AACjB;;AAEA;EACE,+CAA+C;EAC/C,2CAA2C;EAC3C,eAAe;AACjB;;AAEA,sBAAsB;AACtB;EACE,kCAAkC;AACpC;;AAEA,8BAA8B;AAC9B;EACE,sCAAsC;EACtC,kCAAkC;AACpC;;AAEA,uBAAuB;AACvB;EACE,+BAA+B;AACjC;;AAEA,sCAAsC;AACtC;EACE,sBAAsB;EACtB,8BAA8B;AAChC;;AAEA,4BAA4B;AAC5B;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA,yCAAyC;AACzC;EACE,WAAW;AACb;;AAEA;EACE,sCAAsC;EACtC,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;AACpB","sourcesContent":[":root {\n  --primary-color: rgb(31, 64, 90) !important;\n  --secondary-color: rgb(30, 82, 121) !important;\n  --background-light: rgb(239 248 255) !important;\n  --text-white: white !important;\n  --hover-color: rgb(50, 80, 110) !important;\n  --box-shadow: 0 0 10px rgba(0, 0, 0, 0.1) !important;\n  --border-radius: 8px !important;\n  --h2-font-size: 1.3rem !important;\n  --h3-font-size: 1rem !important;\n  --ul-padding: 0rem 0.5rem 1rem 1rem !important;\n  --a-color: rgb(24, 49, 234) !important;\n\n}\n\n.custom-h2 {\n  font-size: var(--h2-font-size);\n  color: var(--primary-color);\n  font-weight: bold;\n  padding-bottom: 10px;\n}\n\nh3 {\n  font-size: var(--h3-font-size);\n  color: var(--secondary-color);\n  font-weight: bold;\n}\n\nul {\n  padding: var(--ul-padding);\n  margin: var(--ul-margin);\n  list-style-type: disc;\n}\n\na {\n  color: var(--a-color);\n}\n\nbody {\n  background-color: var(--background-light);\n}\n\n.userview_container {\n  max-width: 93%;\n  position: inherit;\n}\n\n.bordered-div {\n  padding: 30px;\n  background-color: #f9f9f9;\n  border: 4px solid var(--primary-color);\n  border-radius: var(--border-radius);\n  box-shadow: var(--box-shadow);\n  width: 100%;\n  line-height: 20px;\n  border-top-left-radius: 0;\n}\n\n.inner-content {\n  padding: 20px;\n  text-align: center;\n}\n\np {\n  /* color: var(--primary-color); */\n  font-size: 14px;\n}\n\n.bgv_content {\n  color: var(--primary-color);\n  font-size: 14px;\n}\n\nh1 {\n  margin-left: 30px;\n}\n\n/* Ant Design tabs */\n\n.ant-tabs-nav-list {\n  width: 99%;\n}\n\n.custom-tabs .ant-tabs-tab {\n  color: var(--text-white);\n  font-size: 16px;\n  text-align: center;\n  font-family: Arial, Helvetica, sans-serif;\n  margin: 0;\n  /* background-color: var(--secondary-color); */\n\n}\n\n/* Active Ant Design tabs */\n.custom-tabs .ant-tabs-tab-active {\n  font-weight: bold;\n  background-color: var(--primary-color);\n}\n\nant-tabs-tab-btn {\n  color: #1f415b;\n}\n\n.ant-tabs-nav {\n  /* background-color: var(--background-light); */\n  border-radius: var(--border-radius);\n  /* padding-top: 20px; */\n  /* margin-top: 20px !important; */\n  width: 100%;\n}\n\n.ant-tabs-ink-bar {\n  background-color: var(--text-white);\n}\n\n.ant-tabs-content-holder {\n  /* background-color: var(--background-light); */\n  /* margin-top: -18px; */\n  /* padding-bottom: 20px; */\n}\n\n.custom-button-download {\n  background-color: var(--primary-color) !important;\n  border-color: var(--primary-color) !important;\n  color: var(--text-white) !important;\n  margin-bottom: 10px !important;\n}\n\n.custom-button-upload {\n  background-color: var(--primary-color) !important;\n  border-color: var(--primary-color) !important;\n  color: var(--text-white) !important;\n  margin: 10px !important;\n}\n\n.custom-button-download:hover {\n  background-color: var(--hover-color) !important;\n  border-color: var(--hover-color) !important;\n  font-size: 16px;\n}\n\n.custom-button-upload:hover {\n  background-color: var(--hover-color) !important;\n  border-color: var(--hover-color) !important;\n  font-size: 16px;\n}\n\n/* Checkbox elements */\n.custom-checkbox .ant-checkbox-inner {\n  border-color: var(--primary-color);\n}\n\n/* Checked checkbox elements */\n.custom-checkbox .ant-checkbox-checked .ant-checkbox-inner {\n  background-color: var(--primary-color);\n  border-color: var(--primary-color);\n}\n\n/* Checkbox tick mark */\n.custom-checkbox .ant-checkbox-checked .ant-checkbox-inner::after {\n  border-color: var(--text-white);\n}\n\n/* Card tab navigation in Ant Design */\n.custom-tabs .ant-tabs-card>.ant-tabs-nav .ant-tabs-tab-active {\n  color: #fff !important;\n  background: #1f415b !important;\n}\n\n/* Card tabs in Ant Design */\n.custom-tabs .ant-tabs-card>.ant-tabs-nav .ant-tabs-tab {\n  background: #ddd;\n  color: #1f415b;\n}\n\n/* Active card tab button in Ant Design */\n.custom-tabs .ant-tabs .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {\n  color: #fff;\n}\n\n.custom-header-userattended .ant-table-thead > tr > th {\n  background-color: var(--color-primary); \n  color: white;\n  font-weight: bold;\n  text-align: center;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
